var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18.5058H9.24C9.5058 18.5073 9.76128 18.403 9.95 18.2158L16.87 11.2858L19.71 8.5058C19.8993 8.31803 20.0058 8.06244 20.0058 7.7958C20.0058 7.52916 19.8993 7.27356 19.71 7.0858L15.47 2.7958C15.2822 2.60649 15.0266 2.5 14.76 2.5C14.4934 2.5 14.2378 2.60649 14.05 2.7958L11.23 5.6258L4.29 12.5558C4.10281 12.7445 3.99846 13 4 13.2658V17.5058C4 18.0581 4.44772 18.5058 5 18.5058ZM14.76 4.9158L17.59 7.7458L16.17 9.1658L13.34 6.3358L14.76 4.9158ZM6 13.6758L11.93 7.7458L14.76 10.5758L8.83 16.5058H6V13.6758ZM21 20.5058H3C2.44772 20.5058 2 20.9535 2 21.5058C2 22.0581 2.44772 22.5058 3 22.5058H21C21.5523 22.5058 22 22.0581 22 21.5058C22 20.9535 21.5523 20.5058 21 20.5058Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlt);
export default ForwardRef;